import React, {Component} from 'react';
import {
  Grid,
  Header,
  Icon,
  Label,
  Dropdown,
  Image,
  Modal,
  Input,
  Button,
} from 'semantic-ui-react';
import firebase from './../../firebase';
import AvatarEditor from 'react-avatar-editor';

class UserPanel extends Component {
  state = {
    user: this.props.currentUser,
    modal: false,
    previewImage: '',
    croppedImage: '',
    blob: '',
    storageRef: firebase.storage ().ref (),
    userRef: firebase.auth ().currentUser,
    metadata: {
      contentType: 'image/jpeg',
    },
    uploadedCroppedImage: '',
    usersRef: firebase.database ().ref ('users'),
  };

  // componentWillReceiveProps (nexProps) {
  //   this.setState ({user: nexProps.currentUser});
  // }

  // componentDidMount () {
  //   this.setState ({user: this.props.currentUser});
  // }

  openModal = () => this.setState ({modal: true});
  closeModal = () => this.setState ({modal: false});

  dropDownOptions = () => [
    {
      key: 'user',
      text: (
        <span>Signed in as <strong>{this.state.user.displayName}</strong></span>
      ),
      disabled: true,
    },
    {
      key: 'avatar',
      text: <span onClick={this.openModal}>Change Avatag</span>,
    },
    {
      key: 'signout',
      text: <span onClick={this.handleSignout}>Sign Out</span>,
    },
  ];

  handleChangeImage = event => {
    const file = event.target.files[0];
    const reader = new FileReader ();

    if (file) {
      reader.readAsDataURL (file);
      reader.addEventListener ('load', () => {
        this.setState ({previewImage: reader.result});
      });
    }
  };

  handleSignout = () => {
    firebase.auth ().signOut ().then (() => {
      console.log ('Signout');
    });
  };

  handleCropImage = () => {
    // this.avatarEditor is now on the class
    if (this.avatarEditor) {
      this.avatarEditor.getImageScaledToCanvas ().toBlob (blob => {
        let imageUrl = URL.createObjectURL (blob);
        this.setState ({
          croppedImage: imageUrl,
          blob,
        });
      });
    }
  };

  uploadCroppedImage = () => {
    const {storageRef, userRef, blob, metadata} = this.state;
    storageRef
      .child (`avatars/users/${userRef.uid}`)
      .put (blob, metadata)
      .then (snap => {
        snap.ref.getDownloadURL ().then (downloadURL => {
          this.setState ({uploadedCroppedImage: downloadURL}, () => {
            this.changeAvatar ();
          });
        });
      });
  };

  changeAvatar = () => {
    this.state.userRef
      .updateProfile ({
        photoURL: this.state.uploadedCroppedImage,
      })
      .then (() => {
        console.log ('Photo URL Updated');
        this.closeModal ();
      })
      .catch (err => {
        console.error (err);
      });

    this.state.usersRef
      .child (this.state.userRef.uid)
      .update ({
        avatar: this.state.uploadedCroppedImage,
      })
      .then (() => {
        console.log ('User avatar updated');
      })
      .catch (err => {
        console.error (err);
      });
  };

  render () {
    const {user, modal, previewImage, croppedImage} = this.state;
    const {primaryColor} = this.props;
    return (
      <Grid style={{background: primaryColor}}>
        <Grid.Column>
          <Grid.Row style={{padding: '1.2em', margin: 0}}>
            {/* App Header */}
            <Header inverted floated="left" as="h2">
              <Icon name="code" />
              <Header.Content>
                Dev's Network
              </Header.Content>
              {user.uid === 'MLlT7BWq7iSi7piDNT68JXB8yhC2' &&
                <React.Fragment>
                  <Label as="a" image>
                    <img
                      src="https://avatars2.githubusercontent.com/u/25275856?s=460&v=4"
                      alt="avatar"
                    />
                    <Icon name="superpowers" />Gaurav Gupta
                  </Label>
                  <Label>
                    Creator
                  </Label>
                </React.Fragment>}
            </Header>

            {/* User Dropdown */}
            <Header style={{padding: '0.25em'}} as="h4" inverted>
              <Dropdown
                trigger={
                  <span>
                    <Image src={user.photoURL} spaced="right" avatar />
                    {user.displayName}
                  </span>
                }
                options={this.dropDownOptions ()}
              />
            </Header>
          </Grid.Row>
          {/* Change User Avatar Modal */}
          <Modal basic open={modal} onClose={this.closeModal}>
            <Modal.Header>
              Change Avatar
            </Modal.Header>
            <Modal.Content>
              <Input
                fluid
                onChange={this.handleChangeImage}
                type="file"
                label="New Avatar"
                name="previewImage"
                style={{marginBottom: '22px'}}
              />
              <Grid centered stackable columns={2}>
                <Grid.Row centered>
                  <Grid.Column className="ui center aligned grid">
                    {previewImage &&
                      <AvatarEditor
                        ref={node => (this.avatarEditor = node)}
                        image={previewImage}
                        width={120}
                        height={120}
                        border={50}
                        scale={1.2}
                        rotate={0}
                      />}
                  </Grid.Column>
                  <Grid.Column>
                    {croppedImage &&
                      <Image
                        style={{margin: '3.5em auto'}}
                        width={100}
                        height={100}
                        src={croppedImage}
                      />}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Modal.Content>
            <Modal.Actions>
              {croppedImage &&
                <Button
                  color="green"
                  inverted
                  onClick={this.uploadCroppedImage}
                >
                  <Icon name="save" /> Change Avatar
                </Button>}
              <Button color="green" inverted onClick={this.handleCropImage}>
                <Icon name="image" /> Preview
              </Button>
              <Button color="red" inverted onClick={this.closeModal}>
                <Icon name="remove" /> Cancel
              </Button>
            </Modal.Actions>
          </Modal>
        </Grid.Column>
      </Grid>
    );
  }
}

export default UserPanel;



// WEBPACK FOOTER //
// ./src/components/SidePanel/UserPanel.js